import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logout } from './auth/authSlice';
import { showErrorToast } from 'utils/toast';

const PUBLIC_ENDPOINTS = [
  '/auth/login',
  '/auth/register',
];

const baseQuery = async (args, api, extraOptions) => {
  let shouldSkipToast = false;
  if (typeof args === 'object' && args.body) {
    if (args.body.skipToast !== undefined) {
      shouldSkipToast = args.body.skipToast;
      const { skipToast, ...bodyWithoutSkipToast } = args.body;
      args = { ...args, body: bodyWithoutSkipToast };
    }
  }

  const result = await fetchBaseQuery({
    baseUrl: '/api',
  })(args, api, extraOptions);

  if (!shouldSkipToast && extraOptions?.skipToastOn?.includes(result.error?.status)) {
    shouldSkipToast = true;
  }

  if (result.error && result.error.status === 401) {
    const url = typeof args === 'string' ? args : args.url;
    const isPublicEndpoint = PUBLIC_ENDPOINTS.some(endpoint => url.includes(endpoint));
    
    if (!isPublicEndpoint && !extraOptions?.skipAuthLogout) {
      api.dispatch(logout());
    }
  }

  if (result.error && !shouldSkipToast) {
    showErrorToast(result.error);
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery,
  tagTypes: ['User', 'Designation', 'Team', 'WFH', 'Shift', 'Attendance', 'Analytics', 'Search', 'Mail'],
  endpoints: (builder) => ({}),
});
